import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@els/els-react--checkbox';
import { Button } from '@els/els-react--button';
import RsProjectTableItem from '@Pages/RetroSynthesis/RetroSynthesisProjects/components/RsProjectTableItem';
import { ProjectStatus } from '../../constants';
import { onGroupExpandCollapse } from '../analytics';

import './RsProjectTableGroup.scss';

const getExpandedState = (predictedStatus) => {
  return predictedStatus === ProjectStatus.IN_PROGRESS || predictedStatus === ProjectStatus.IN_QUEUE;
};

function RsProjectTableGroup({ project, childProjects, ...props }) {
  const defaultExpanded = childProjects.length && getExpandedState(childProjects[0].rtStatus);

  const [isExpanded, setIsExpanded] = useState(defaultExpanded);
  const collapsedChildProject = !isExpanded && childProjects.length ? childProjects[0] : null;

  const isAllGroupProjectsSelected =
    childProjects.every((childProject) => props.selectedIds.includes(childProject.id)) && props.selectedIds.includes(project.id);
  const isAnyGroupProjectsSelected =
    childProjects.some((childProject) => props.selectedIds.includes(childProject.id)) || props.selectedIds.includes(project.id);

  useEffect(() => {
    if (!childProjects.length) return;
    setIsExpanded(getExpandedState(childProjects[0].rtStatus));
  }, [childProjects]);

  const handleGroupSelectionChange = (e) => {
    const { checked } = e.target;
    props.onSelectionChange({
      targetId: project.id,
      value: checked,
    });
    childProjects.forEach((childProject) => {
      props.onSelectionChange({
        targetId: childProject.id,
        value: checked,
      });
    });
  };

  const expandCollapseGroup = () => {
    onGroupExpandCollapse(!isExpanded, [project, ...childProjects]);
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <tr className="group-header">
        <td colSpan="7">
          <div className="group-header-container">
            <div className="group-header-controls">
              <Checkbox
                className="project-checkbox"
                onChange={handleGroupSelectionChange}
                checked={isAllGroupProjectsSelected}
                indeterminate={isAnyGroupProjectsSelected && !isAllGroupProjectsSelected}
                label={`Grouping of Project #${project.id}`}
                shouldHideLabel
              />
              <div>Grouping of Project #{project.id}</div>
            </div>
            <div className="group-header-controls">
              <Button
                aria-label={`${isExpanded ? 'Collapse' : 'Expand'} group projects`}
                type="tertiary"
                onClick={expandCollapseGroup}
                size="x-small"
                className="params__toggle-btn-i group-header-toggle_button">
                <svg className="els-btn-icon els-btn-icon-tiny">
                  <use xlinkHref={isExpanded ? '#icon-chevron-up' : '#icon-chevron-down'} />
                </svg>
              </Button>
              <span>{isExpanded ? 'Collapse' : 'Expand'}</span>
            </div>
          </div>
        </td>
      </tr>
      {collapsedChildProject && (
        <RsProjectTableItem
          className="group-row"
          key={collapsedChildProject.id}
          {...props}
          id={collapsedChildProject.id}
          project={collapsedChildProject}
        />
      )}
      {!collapsedChildProject &&
        childProjects.map((childProject) => {
          return <RsProjectTableItem className="group-row" key={childProject.id} {...props} id={childProject.id} project={childProject} />;
        })}
      {!collapsedChildProject && <RsProjectTableItem className="group-row" key={project.id} {...props} id={project.id} project={project} />}
      <tr className="group-footer">
        <td colSpan="7">
          <div className="group-footer-container" />
        </td>
      </tr>
    </>
  );
}

RsProjectTableGroup.defaultProps = {
  selectedIds: [],
  onSelectionChange: () => {},
};

RsProjectTableGroup.propTypes = {
  project: PropTypes.object.isRequired,
  childProjects: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  onSelectionChange: PropTypes.func,
};

export default RsProjectTableGroup;
